import { Button } from './Button';
import { CircularProgress } from './CircularProgress';
import { Input } from './Input';
import { Link } from './Link';
import { Modal } from './Modal';
import { Spinner } from './Spinner';
import { Table } from './Table';

export default { Button, Modal, Input, Spinner, Table, Link, CircularProgress };
